import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JourneyComponent } from './journey.component';
import { LocationPipeModule } from 'libraries/pipes/location/location.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        LocationPipeModule,
        FontAwesomeModule,
    ],
  declarations: [
    JourneyComponent,
  ],
  exports: [JourneyComponent]
})
export class JourneyModule {}